import { useRouter } from 'next/router'
import React from 'react'

import { FormattedMessage } from 'react-intl'

import { Estimate } from '@/lib/types'
import { formatCurrency } from '@/lib/utils'

import useExchangeRates from '@/hooks/finances/useExchangeRates'

import Icon from '@/components/Icon'
import Tooltip from '@/components/Tooltip'

export const HostingTooltip = ({
  monthlyEstimate,
  dailyEstimate
}: {
  monthlyEstimate?: Estimate
  dailyEstimate?: Estimate
}) => {
  const { locale } = useRouter()
  const { rates } = useExchangeRates()

  const usdRate = rates ? rates['USD/RUB']?.value : 0
  const monthlyExpense = monthlyEstimate?.expenses || 0
  const dailyExpense = dailyEstimate?.expenses || 0

  const monthlyRUBHosting = monthlyExpense * usdRate || 0
  const monthlyUSDHosting = monthlyExpense
  const dailyRUBHosting = dailyExpense * usdRate || 0
  const dailyUSDHosting = dailyExpense

  return (
    <Tooltip
      contentComponent={
        <div className="flex w-[290px] flex-col gap-3 px-1 py-2 text-left text-x-sm">
          <span className="text-x-base font-medium">
            <FormattedMessage
              {...{
                id: 'device.tooltip.hosting.title',
                defaultMessage:
                  'Стоимость расходов зависит {br} от курса рубля',
                values: { br: <br /> }
              }}
            />
          </span>
          <div className="flex flex-col gap-1.5">
            <span className="text-secondary-500">
              <FormattedMessage
                {...{
                  id: 'device.tooltip.hosting.rate',
                  defaultMessage: 'Текущий курс'
                }}
              />
            </span>
            <span className="text-xl font-medium">
              {formatCurrency(1_00, 'USD', locale)} ={' '}
              {formatCurrency(usdRate * 100 || 0, 'RUB', locale)}
            </span>
          </div>
          <div className="grid grid-cols-2 gap-[9px]">
            <div className="flex flex-col rounded-[10px] bg-sky-200 px-2.5 py-2">
              <span className="text-secondary-500">
                <FormattedMessage
                  {...{
                    id: 'device.tooltip.hosting.month',
                    defaultMessage: 'Хостинг в месяц'
                  }}
                />
              </span>
              <span className="text-xl font-medium">
                {formatCurrency(monthlyRUBHosting, 'RUB', locale)}
              </span>
              <span>~{formatCurrency(monthlyUSDHosting, 'USD', locale)}</span>
            </div>

            <div className="flex flex-col rounded-[10px] bg-sky-200 px-2.5 py-2">
              <span className="text-secondary-500">
                <FormattedMessage
                  {...{
                    id: 'device.tooltip.hosting.day',
                    defaultMessage: 'Хостинг в день'
                  }}
                />
              </span>
              <span className="text-xl font-medium">
                {formatCurrency(dailyRUBHosting, 'RUB', locale)}
              </span>
              <span>~{formatCurrency(dailyUSDHosting, 'USD', locale)}</span>
            </div>
          </div>
        </div>
      }
    >
      <Icon
        className="h-5 w-5 cursor-pointer text-secondary-500"
        name="info-italic-16"
      />
    </Tooltip>
  )
}
